import type { CSSProperties } from 'react';

export const DEFAULT_HERO_CAROUSEL_BG = '#b8121a';

const HEX_COLOR_RE = /^#[0-9A-Fa-f]{6}$/;

export function normalizeHeroCarouselHex(color?: string): string {
  const raw = (color ?? '').trim();
  if (!raw) return DEFAULT_HERO_CAROUSEL_BG;
  const normalized = raw.startsWith('#') ? raw : `#${raw}`;
  return HEX_COLOR_RE.test(normalized) ? normalized.toLowerCase() : DEFAULT_HERO_CAROUSEL_BG;
}

/** Match the default CWY hero gradient using a custom base color. */
export function heroPromoBackgroundStyle(color?: string): CSSProperties {
  const base = normalizeHeroCarouselHex(color);
  return {
    background: `linear-gradient(180deg, color-mix(in srgb, ${base} 94%, white) 0%, ${base} 45%, color-mix(in srgb, ${base} 88%, black) 100%)`,
  };
}
